export default {
  en: {
    type: {
      closed: 'Closed',
      open: 'Open',
      private: 'Private',
    },
    members: {
      one: '%{count} member',
      other: '%{count} members',
    },
    infoBtn: {
      more: 'More info',
      less: 'Less info',
    },
  },
};
